import { useState, useEffect } from "react";
const API_URL = process.env.REACT_APP_URL;

function WaitlistSSE() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const endpoint = `${API_URL}api/waitlist/events`;

  useEffect(() => {
    let eventSource;
    let reconnectInterval = 5000;
    let reconnectTimer;

    const connect = () => {
      eventSource = new EventSource(endpoint);

      eventSource.onopen = () => {
        reconnectInterval = 5000;
      };

      eventSource.onmessage = (event) => {
        const parsedData = JSON.parse(event.data);
        setData({ entry: parsedData, ts: Date.now() });
        setError(null);
      };

      eventSource.onerror = (err) => {
        console.error("Waitlist EventSource error:", err);
        eventSource.close();
        reconnectTimer = setTimeout(connect, reconnectInterval);
        reconnectInterval = Math.min(reconnectInterval * 2, 60000);
        setError(err);
      };
    };

    connect();

    return () => {
      if (eventSource) eventSource.close();
      if (reconnectTimer) clearTimeout(reconnectTimer);
    };
  }, [endpoint]);

  return { data, error };
}

export default WaitlistSSE;
